/** @file rotateZScaled: a rotation applied in the rotation space whose z axis is scaled by zScaleRotate. */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import { quatRotateVec3 } from '@zilo/pose3d-math/quat/quatRotateVec3';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/** `r = q (v.x, v.y, v.z / s)`, returned as `(r.x, r.y, r.z * s)` (decision 7, 17.7). */
export function rotateZScaled(q: Quat, v: Vec3, zScale: number): Vec3 {
  const r = quatRotateVec3(q, [v[0], v[1], v[2] / zScale]);
  return [r[0], r[1], r[2] * zScale];
}
